import { Text } from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";
import { useAdoRefreshStatus } from "../../hooks/useAdoRefresh";
import { useRefreshStatusBannerStyles } from "./RefreshStatusBanner.styles";

export const RefreshStatusBanner = (): JSX.Element | null => {
  const styles = useRefreshStatusBannerStyles();
  const { data: refreshStatus } = useAdoRefreshStatus();

  if (!refreshStatus?.in_progress) return null;

  const progress = refreshStatus.progress;
  const total = progress?.total;
  const hasTotal = progress != null && total != null && total > 0;
  const progressValue = hasTotal
    ? Math.round((progress.current / total) * 100)
    : null;

  return (
    <div
      className={styles.container}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <div className={styles.header}>
        <div className={styles.icon} aria-hidden="true">
          <Info16Regular />
        </div>
        <Text className={styles.title}>Refreshing Azure DevOps data…</Text>
      </div>
      <div className={styles.progressSection}>
        <div
          className={styles.progressBar}
          role="progressbar"
          aria-label="Azure DevOps refresh progress"
          aria-valuenow={progressValue ?? undefined}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div
            className={styles.progressFill}
            style={{ width: `${progressValue ?? 0}%` }}
          />
        </div>
        <div className={styles.progressMeta}>
          <span>
            {hasTotal
              ? `Processing team ${progress.current} of ${total}`
              : "Processing…"}
          </span>
          {hasTotal && (
            <span className={styles.progressMetaValue}>
              {progressValue}% complete
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
